import { required, pattern } from 'validx';
import global from 'global';

export const contactMessageValidationSchema = () => {
  const t = global.t;

  return {
    // The schema maps to the fields we are validating.
    FromName: [
      required({ msg: t('Email is required') }),
      pattern({
        pattern: 'email',
        msg: t('This email address does not seem to be valid.'),
      }),
    ],
    Header: [required({ msg: t('Full Name is required') })],
    Body: [required({ msg: t('Message is required') })],
  };
};
